export default {
  OFFLINE: 1,
  PREVIEW: 2,
  JOINING: 3,
  JOINED: 4,
};
